import React from 'react';
import { Link, useLocation} from 'react-router-dom';
import styles from './Footer.module.css';
import {
    FaInstagram,
    FaTiktok
} from 'react-icons/fa';

const Footer = () => {
    const location = useLocation();
  
    const fixedFooterPages = ['/notavl', '/delivery'];
    const isFixedFooter = fixedFooterPages.includes(location.pathname);
  
    return (
        <footer className={`${styles.footer} ${isFixedFooter ? styles.fixedFooter : ''}`}>
            <div className={styles.socialLinks}>
                <a
                    target="_blank" rel="noopener noreferrer"
                    href="https://www.instagram.com/the.luminis/"
                    aria-label="Instagram"
                    >
                    <FaInstagram />
                </a>

                <a
                    target="_blank" rel="noopener noreferrer"
                    href="https://www.tiktok.com/@theluminis"
                    aria-label="TikTok"
                    >
                    <FaTiktok />
                </a>
            </div>
            <p>Телефон: +359 879 330 389</p>
            <p>Имейл: theluminis@outlook.com</p>
            <Link to="/delivery" className={styles.link}>Доставка и плащане</Link>
            
            <p>&copy; {new Date().getFullYear()} Luminis. <Link to="/privacy" className={styles.linkPrivacy}>Политика за поверителност</Link></p>
        </footer>
    );
};

export default Footer;
